import {Link} from "react-router";

import {shortDateTime} from "@/lib/format.tsx";
import {DateFormatName, TimeFormatName} from "@/lib/types/common.ts";

interface ServiceRequestedProps {
  dateFormat: DateFormatName;
  limitName: string;
  requestSent: string;
  timeFormat: TimeFormatName;
  timezone: string;
}

export const ServiceRequested = ({limitName, requestSent, dateFormat, timeFormat, timezone}: ServiceRequestedProps) => (
  <small>
    <p>
      You have reached the maximum number of <strong>{limitName}</strong> Checks available in your account.
    </p>
    <p>
      A purchase request <strong>was sent</strong> to the owner of this account on{" "}
      {shortDateTime(requestSent, dateFormat, timeFormat, timezone)}. Once it is paid, the requested Checks will be
      added to the account.
    </p>
    <p>
      If you have any questions don’t hesitate to <Link to="/contact">contact us</Link>.
    </p>
  </small>
);
